import React, { useState } from "react";
import { Row } from "reactstrap";
import { LoadingButton } from "../../../components/LoadingButton";
import { adminApi, extractErrorMessage } from "../../../util/api";

export const TestConnectionButton = ({ onError, onSuccess, connection, resourcePath }) => {
  const [testing, setTesting] = useState(false);

  const handleTesting = async () => {
    setTesting(true);

    try {
      await adminApi.post(`${resourcePath}/sftp_connection_settings/test_connection`, connection);
      onSuccess("Connection Successful");
      setTesting(false);
    } catch (err) {
      onError(extractErrorMessage(err));
    } finally {
      setTesting(false);
    }
  };

  return (
    <Row>
      <LoadingButton loading={testing} color="link" className="text-danger" onClick={handleTesting}>
        Test Connection
      </LoadingButton>
    </Row>
  );
};
